import {
    coffee1,
    coffee2,
    coffee3,
    coffee4,
    coffee5,
    coffee6,
    coffee7,
    coffee8,
    coffee9,
    coffee10,
} from '../utils/CollectionImage';

import {
    tea1,
    tea2,
    tea3,
    tea4,
    tea5,
    tea6,
    tea7,
    tea8,
} from '../utils/CollectionImage';

const CoffeeAtHomeData = [
    {
        img: coffee1,
        title: 'Thùng Cà Phê Sữa Espresso',
        price: '336.000 đ',
    },
    {
        img: coffee2,
        title: 'Combo 6 Lon Cà Phê Sữa Espresso',
        price: '84.000 đ',
    },
    {
        img: coffee3,
        title: 'Cà Phê Rang Xay Original 1 Túi 1KG',
        price: '235.000 đ',
    },
    {
        img: coffee4,
        title: 'Cà Phê Hòa Tan Đậm Vị Việt Túi 40x16G',
        price: '99.000 đ',
    },
    {
        img: coffee5,
        title: 'Cà Phê Rang Xay Original 1 250g',
        price: '60.000 đ',
    },
    {
        img: coffee6,
        title: 'Cà Phê Sữa Đá Hòa Tan (10 gói x 22g)',
        price: '44.000 đ',
    },
    {
        img: coffee7,
        title: 'Cà Phê Hoà Tan Đậm Vị Việt (18 gói x 16 gam)',
        price: '48.000 đ',
    },
    {
        img: coffee8,
        title: 'Cà Phê Sữa Đá Hòa Tan Túi 25x22G',
        price: '99.000 đ',
    },
    {
        img: coffee9,
        title: 'Cà Phê Sữa Đá Pack 6 Lon',
        price: '84.000 đ',
    },
    {
        img: coffee10,
        title: 'Thùng 24 Lon Cà Phê Sữa Đá',
        price: '336.000 đ',
    },
];

const TeaAtHomeData = [
    {
        img: tea1,
        title: 'Trà Vị Đào Tearoma 14x14g',
        price: '32.000 đ',
    },
    {
        img: tea2,
        title: 'Trà Sữa Trân Châu Tearoma 250g',
        price: '38.000 đ',
    },
    {
        img: tea3,
        title: 'Trà Vị Tắc Mật Ong Tearoma 14x14g',
        price: '32.000 đ',
    },
    {
        img: tea4,
        title: 'Trà Oolong Túi Lọc Tearoma 20x2G',
        price: '28.000 đ',
    },
    {
        img: tea5,
        title: 'Trà Lài Túi Lọc Tearoma 20x2G',
        price: '28.000 đ',
    },
    {
        img: tea6,
        title: 'Trà Sen Túi Lọc Tearoma 20x2G',
        price: '28.000 đ',
    },
    {
        img: tea7,
        title: 'Trà Đào Túi Lọc Tearoma 20x2G',
        price: '28.000 đ',
    },
    {
        img: tea8,
        title: 'Giftset Trà Tearoma',
        price: '166.000 đ',
    },
];

export { CoffeeAtHomeData, TeaAtHomeData };
